import { intl } from "LocaleWrapper";
import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";

const ReeferLocationTypeSelect = ({
	...rest
}: Omit<SelectProps<string, false>, "fetchOptions" | "paginated">) => {
	return (
		<Select
			{...rest}
			fetchOptions={[ "ship", "bin" ]}
			getOptionLabel={option => intl.formatMessage({ id: option === "ship" ? "REEFER_LOCATION_TYPE_SHIP" : "REEFER_LOCATION_TYPE_BIN" })}
			disableSearch />
	);
};

export default ReeferLocationTypeSelect;
